<template>
  <v-container>
    <v-form ref="form" v-model="validado">
      <v-row dense>
        <!-- Botón de regreso -->
        <v-row dense class="align-center justify-space-between">
          <v-col cols="auto">
            <v-btn icon class="mb-2" @click="$router.push('/ru/pecuarios')">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <!-- <v-btn class="cancel" @click="Cancelar"> Cancelar </v-btn> -->
            <!-- <form-meta
            :data="registro"
            :remove-commit="'removerPecuaria'"
            :record-id="registro.id"
            @removed="$router.go(-1)"
          /> -->
            <save-btn
              class="btn-oval"
              :record-status="registro.estatus"
              :loading="loading"
              @click="antesDeGuardar"
            />
          </v-col>
        </v-row>

        <v-col cols="12">
          <!-- <span style="font-size: 30px">🐂 🐄</span> -->
          <div style="text-align: center" class="text-h4 font-weight-bold">
            {{
              nuevoPecuario
                ? 'Crea Nuevo Lote de Ceba o Engorde'
                : 'Lote de Ceba, Peso y Venta Pecuaria'
            }}
          </div>
        </v-col>
        * En Azul campos necesarios
        <v-col cols="12">
          <div class="text-h7">
            Agrega o busca la Finca de tu Lote de Ganado
          </div>
        </v-col>
        <!-- <v-col cols="12">
          <div class="font-weight-medium grey--text text--darken-2">
            Los campos con * son importantes
          </div>
        </v-col> -->
        <!-- Criterios de búsqueda -->
        <v-col cols="12">
          <v-select
            ref="fincaSelect"
            v-model="registro.id_finca"
            :no-data-text="$vuetify.noDataText"
            :rules="[r.required]"
            :items="fincas"
            item-text="nombre"
            item-value="id"
            label="Finca *"
            outlined
            :disabled="busquedaFin"
            @input="onFincaChange()"
          >
            <template slot="item" slot-scope="{ item }">
              <finca-select-item :item="item" />
            </template>
          </v-select>
        </v-col>
        <v-col cols="12">
          <div class="font-weight-medium grey--text text--darken-2">
            Presiona botón CREA NUEVO para tú nuevo Lote
          </div>
        </v-col>
        <v-row>
          <v-col cols="9">
            <v-select
              ref="parcelaSelect"
              v-model="registro.id_parcela"
              :no-data-text="$vuetify.noDataText"
              :rules="[r.required]"
              clearable
              outlined
              :items="parcelasPorId(registro.id_finca)"
              item-value="id"
              item-text="nombre"
              label="Nombre del Lote de Ganado *"
              :disabled="busquedaFin"
              @input="onParcelaChange()"
            />
          </v-col>
          <v-col cols="3">
            <div class="justify-end">
              <modal-parcela />
            </div>
          </v-col>
        </v-row>
        <!-- <v-col cols="6">
          <v-text-field
            v-model.number="registro.ciclo"
            :rules="[r.required, r.int, r.min_num(1), r.max_num(9)]"
            label="Ciclo*"
            outlined
            @input="debounceBuscarRegistroExistente"
          />
        </v-col> -->
        <v-col cols="12">
          <div class="font-weight-medium grey--text text--darken-2">
            Fecha de Inicio del Lote, Ejemplo: 2025-01-30
          </div>
        </v-col>
        <v-col cols="9">
          <v-combobox
            ref="fechaInicio"
            v-model="registro.fecha"
            :items="fechasSugeridas"
            label="Fecha que Inicio este Lote *"
            :rules="[r.required]"
            placeholder="aaaa-mm-dd"
            outlined
            clearable
            :disabled="busquedaFin"
            @change="validarFecha"
          >
          </v-combobox>
          <p v-if="errorin" style="color: red">{{ errorin }}</p>
        </v-col>
        <v-col cols="2" class="d-flex align-center">
          <v-btn color="primary" block @click="onFechaChange">
            Siguiente
          </v-btn>
        </v-col>
        <!--  <v-col cols="2" class="d-flex align-center">
          <v-icon
            @mousedown.prevent="onFechaChange"
            color="primary"
            style="cursor: pointer; font-size: 35px"
          >
            mdi-magnify
          </v-icon>
        </v-col> -->
        <!-- Mensaje de estado de búsqueda -->
        <v-col v-if="mensajeBusqueda" cols="12">
          <v-alert
            :type="tipoMensaje"
            :value="true"
            dismissible
            @input="limpiarMensaje"
          >
            {{ mensajeBusqueda }}
          </v-alert>
        </v-col>

        <!-- Indicador de carga -->
        <v-col v-if="buscandoRegistro && !nuevoPecuario" cols="12">
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
          <div class="text-center text-body-2 mt-2">
            Buscando registro existente...
          </div>
        </v-col>

        <v-col cols="12">
          <v-divider style="border: 1px solid black"></v-divider>
        </v-col>
        <!--Duración de la Producción en Meses -->
        <!--    <v-col cols="6">
          <v-text-field
            v-model="registro.duracionProduccion"
            label="Duración Produccion(meses)"
            type="number"
            outlined
            readonly
          />
        </v-col> -->

        <!-- {{actividad_pecuaria}} -->
        <!--  <v-col cols="5">
          <v-select v-model="registro.id_actividad_pecuaria" :no-data-text="$vuetify.noDataText" :rules="[r.required]"
            :items="rubros_filtrados" item-text="descripcion" item-value="id" label="Especie*" outlined
            @input="debounceBuscarRegistroExistente">
            <template v-slot:selection="props">
              <div v-text="props.item[props.parent.$props.itemText]" />
            </template>
          </v-select>
        </v-col> -->
        <!-- <v-col cols="6">
          <modal-establecimiento />
          <v-select
            v-model="registro.id_establecimiento"
            :no-data-text="$vuetify.noDataText"
            clearable
            outlined
            :items="establecimientosPorId(registro.id_finca)"
            item-value="id"
            item-text="rua"
            label="RUA"
          ></v-select>
        </v-col> -->

        <!--   <v-col cols="6">
          <v-text-field
            v-model="registro.fecha_fin"
            label="Fecha Final"
            outlined
            placeholder="yyyy-mm-dd"
            @change="handleFechaChange"
          >
          </v-text-field>
          <p v-if="errorhas" style="color: red">{{ errorhas }}</p>
        </v-col> -->
      </v-row>
      <!-- <v-col cols="3">
          <v-text-field v-model="registro.produccion" label="Producción*" outlined>
            <template v-slot:append>
              <unit-picker :group="`to_${guessUnit(registro.id_actividad_pecuaria)}`"
                @transform="registro.produccion = $event" />
            </template>
            <template v-slot:append-outer>
            </template>
          </v-text-field>
        </v-col> -->
      <!-- Campo para tipo de sistema -->
      <!--  <v-col cols="3">
      <v-select
        label="Tipo de Sistema"
        outlined
      />
    </v-col> -->
      <!-- Campo para rendimiento esperado -->
      <!-- <v-col cols="4">
          <v-text-field
            v-model="registro.rendimiento_esperado"
            label="Rendimiento Esperado (%)"
            outlined
          />
        </v-col> -->

      <!-- AQUI botones de entrada, engorde, produccion y venta-->
      <v-row class="pa-2" align="center" justify="space-between">
        <v-col cols="3" class="d-flex justify-center">
          <v-btn
            :color="activeTab === 'ingreso' ? 'green darken-3' : 'primary'"
            class="white--text"
            small
            @click="pmostrarIngreso()"
          >
            <v-icon>mdi-cow</v-icon>
            1.Lote Ceba
          </v-btn>
        </v-col>
        <v-col cols="2" class="d-flex justify-center">
          <v-btn
            :color="activeTab === 'engorde' ? 'green darken-3' : 'primary'"
            class="white--text"
            small
            @click="pmostrarEngorde()"
          >
            <v-icon>mdi-weight</v-icon>
            2.Pesaje
          </v-btn>
        </v-col>
        <!--  <v-col cols="6" sm="3" md="3">
          <v-btn
          color="success"
          class="w-100"
          @click="
          mostrarProduccion = !mostrarProduccion
          if (mostrarProduccion) {
            mostrarInventario = false
            mostrarEngorde = false
            mostrarVenta = false
            }"
            >
            <v-icon left>mdi-eye</v-icon>
            Producción
            </v-btn>
          </v-col> -->
        <v-col cols="2" class="d-flex justify-center">
          <v-btn
            :color="activeTab === 'venta' ? 'green darken-3' : 'primary'"
            class="white--text"
            small
            @click="pmostrarVenta()"
          >
            <v-icon left>mdi-currency-usd</v-icon>
            3.Venta
          </v-btn>
        </v-col>
      </v-row>
      <!-- listado dinámico de producciones pecuarias -->

      <!-- Situación de desastre -->
      <!-- <v-col cols="12">
          <v-btn depressed block class="primary--text" @click="agregarDesastre">
            <v-icon left>mdi-plus</v-icon>
            Agregar situación de desastre
          </v-btn>
        </v-col>
        <situacion-de-desastre
          v-for="(desastre, index) in registro.desastres"
          :key="desastre.id_trxdano"
          :form="registro.desastres[index]"
          :modulo="'PECUARIO'"
          @eliminar="eliminarDesastre(index)"
        /> -->
      <template v-if="nuevoPecuario || registro.id">
        Selecciona cada botón verde para tú inventario, pesaje y ventas
        <v-row v-if="mostrarInventario" class="pa-2" justify="start">
          <v-col cols="12" class="mt-n6">
            <div class="subtitle-1 grey--text">
              Presiona el botón Agrega Nuevo para agregar ganado a tu Lote.
            </div>
          </v-col>
          <v-col cols="4">
            <v-btn
              block
              rounded
              class="primary--text"
              @click="agregarProduccionYEditar"
            >
              <v-icon left>mdi-plus</v-icon>
              Agrega Nuevo Ganado a Ceba
            </v-btn>
          </v-col>

          <!-- AQUI -->
          <v-col cols="12" v-if="indexEdicion !== null">
            <v-card outlined class="pa-4 mb-4">
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="
                      registro.producciones[indexEdicion].id_actividad_pecuaria
                    "
                    :no-data-text="$vuetify.noDataText"
                    :rules="[r.required]"
                    :items="actividad_pecuaria"
                    item-text="descripcion"
                    item-value="id"
                    label="Tipo de Ganado *"
                    ref="tipoGanadoSelect"
                    outlined
                    @input="handleActividadChange(indexEdicion)"
                    @change="
                      () => {
                        if (
                          isDiagnosticoPecuario(
                            registro.producciones[indexEdicion]
                              .id_actividad_pecuaria
                          )
                        ) {
                          registro.producciones[indexEdicion].cantidad = null
                          registro.producciones[indexEdicion].peso_inicial = 0
                        } else {
                          registro.producciones[indexEdicion].haespecia = null
                        }
                      }
                    "
                  >
                    <template v-slot:selection="props">
                      <div v-text="props.item[props.parent.$props.itemText]" />
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-combobox
                    v-model="registro.producciones[indexEdicion].identirubro"
                    label="Número o Nombre Unico*"
                    :rules="[r.required]"
                    outlined
                    :items="IdentirubroSugeridos"
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model.number="
                      registro.producciones[indexEdicion].peso_inicial
                    "
                    :rules="[r.required, r.float, r.min_num(0)]"
                    type="number"
                    label="Peso Inicial (kg) *"
                    outlined
                  >
                    <template v-slot:append>
                      <unit-picker
                        @transform="
                          registro.producciones[indexEdicion].peso_inicial =
                            $event
                        "
                      />
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="registro.producciones[indexEdicion].cantidad"
                    :rules="[r.required]"
                    label="Cantidad de ganado *"
                    outlined
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="registro.producciones[indexEdicion].costo_inicial"
                    :rules="[r.required, r.float, r.min_num(0)]"
                    label="Costo Inicial *"
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="registro.producciones[indexEdicion].sexo"
                    :items="sexoOptions"
                    item-text="text"
                    item-value="value"
                    outlined
                    label="Sexo"
                    :placeholder="
                      registro.producciones[indexEdicion].sexo
                        ? ''
                        : 'Sin seleccionar'
                    "
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="registro.producciones[indexEdicion].fechanac"
                    label="Fecha de nacimiento"
                    placeholder="aaaa-mm-dd"
                    outlined
                    :error="!!errorn[`fechanac_${indexEdicion}`]"
                    :error-messages="errorn[`fechanac_${indexEdicion}`] || ''"
                    @change="validarFechaNac"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="registro.producciones[indexEdicion].raza"
                    outlined
                    label="Raza"
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="registro.producciones[indexEdicion].codigo_rubro"
                    label="Código dipositivo de Trazabilidad"
                    outlined
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="registro.producciones[indexEdicion].color"
                    :items="color"
                    label="Color"
                    outlined
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="registro.producciones[indexEdicion].origen"
                    outlined
                    label="Origen o Procedencia"
                  />
                </v-col>
                <v-col cols="6" md="4">
                  <v-text-field
                    v-model="registro.producciones[indexEdicion].codigop"
                    outlined
                    label="Codigo de Padre"
                  />
                </v-col>
                <v-col cols="6" md="4">
                  <v-text-field
                    v-model="registro.producciones[indexEdicion].codigom"
                    outlined
                    label="Codigo de Madre "
                  />
                </v-col>
                <v-col cols="6" md="4">
                  <v-select
                    v-model="
                      registro.producciones[indexEdicion].nacimiento_cria
                    "
                    :items="criaNacidadOptions"
                    item-text="text"
                    item-value="value"
                    outlined
                    label="Cria nacidad en?"
                  />
                </v-col>
                <v-col cols="6" md="4">
                  <v-text-field
                    v-model="registro.producciones[indexEdicion].nombre_ganado"
                    outlined
                    label="Otra identificación Ganado"
                  />
                </v-col>
                <v-col cols="6" md="4">
                  <v-text-field
                    v-model="registro.producciones[indexEdicion].salida"
                    outlined
                    label="Fecha de Salida"
                    :date.sync="registro.producciones[indexEdicion].salida"
                    placeholder="aaaa-mm-dd"
                    :error-messages="errors[`salida_${indexEdicion}`] || []"
                    @change="validarFechaSalida(indexEdicion)"
                  />
                </v-col>
                <v-col cols="6" md="4">
                  <v-select
                    v-model="registro.producciones[indexEdicion].tipo_salida"
                    :items="tipoSalidaOptions"
                    item-text="text"
                    item-value="value"
                    outlined
                    label="Tipo de Salida"
                    clearable
                  />
                </v-col>
                <v-col cols="6" md="6" class="d-flex align-end">
                  <v-btn color="primary" @click="guardarEntrada">
                    Siguiente
                  </v-btn>
                </v-col>
                <v-col cols="6" md="3" class="d-flex">
                  <v-btn icon @click="eliminarFilaProduccion(indexEdicion)">
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <!-- listado de producciones (entradas) -->
          <v-col
            cols="12"
            v-for="(item, index) in registro.producciones"
            :key="index"
          >
            <v-card
              outlined
              class="pa-0 custom-border"
              :style="
                index === indexEdicion
                  ? 'border: 2.8px solid #ff9800;'
                  : 'border: 2.8px solid #4caf50;'
              "
              @click="editarProduccion(index)"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">
                    <strong>Animal:</strong>
                    {{ descripcionActividad(item.id_actividad_pecuaria) || '' }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Peso Inicial: {{ item.peso_inicial }} kg - Cantidad:
                    {{ item.cantidad }} - Sexo: {{ sexoTexto(item.sexo) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Fecha de Nacimiento: {{ item.fechanac || '' }} - Raza:
                    {{ item.raza || '' }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Fecha de Salida: {{ item.salida || '' }} - Por:
                    {{ item.tipo_salida || '' }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Identificación de Ganado: {{ item.identirubro }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>

        <!-- Contenedor con scroll horizontal y vertical -->
        <!-- <v-col cols="12">
          <div
            style="
              overflow-y: auto;
              max-height: 400px;
              width: 100%;
              border: 1px solid #ccc;
            "
          >
            <table class="custom-table">
              <thead>
                <tr>
                  <th v-for="header in headers_produccion" :key="header.value">
                    {{ header.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in registro.producciones"
                  :key="`producciones-${index}`"
                >
                  <td>
                    <v-btn
                      small
                      color="primary"
                      @click="mostrarFormularioEdicion(index)"
                    >
                      Ver
                    </v-btn>
                  </td>

                  <td>
                    <v-select
                      v-model="item.id_actividad_pecuaria"
                      :no-data-text="$vuetify.noDataText"
                      :rules="[r.required]"
                      :items="actividad_pecuaria"
                      item-text="descripcion"
                      item-value="id"
                      label="Rubro*"
                      style="width: 200px"
                      @input="handleActividadChange(index)"
                      @change="
                        () => {
                          if (
                            isDiagnosticoPecuario(item.id_actividad_pecuaria)
                          ) {
                            item.cantidad = null
                            item.produccion = 0
                          } else {
                            item.haespecia = null
                          }
                        }
                      "
                    >
                      <template v-slot:selection="props">
                        <div
                          v-text="props.item[props.parent.$props.itemText]"
                        />
                      </template>
                    </v-select>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.identirubro"
                      placeholder="Código"
                      outlined
                    />
                  </td>

                  <td>
                    <v-text-field
                      v-model="item.cantidad"
                      :rules="[r.float, r.min_num(0), r.max_num(10000000)]"
                      placeholder="Cantidad"
                      style="width: 100px"
                      outlined
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model.number="item.produccion"
                      :rules="[r.required, r.float, r.min_num(0)]"
                      label="Peso*"
                      outlined
                      style="width: 125px"
                    >
                    </v-text-field>
                  </td>

                  <td>
                    <v-text-field style="width: 10px">
                      <template v-slot:append>
                        <unit-picker
                          :group="`to_${guessUnit(item.id_actividad_pecuaria)}`"
                          @transform="item.produccion = $event"
                        />
                      </template>
                    </v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.fechanac"
                      label="Fecha de nacimiento"
                      outlined
                      type="date"
                      placeholder="yyyy-mm-dd"
                    />
                  </td>

                  <td>
                    <v-select
                      v-model="item.color"
                      style="width: 100px"
                      :items="[
                        'Blanco',
                        'Negro',
                        'Rojo',
                        'Café o Marrón',
                        'Gris',
                        'Rubio o Amarillento',
                        'Manchado (negro y blanco)',
                        'Overo (rojo y blanco)',
                        'Pintado (blanco y marrón o con negro)',
                        'Dorado o Bayo',
                        'Atigrado (franjas oscuras y claras)',
                        'Cintillo Blanco (cara blanca y cuerpo negro)',
                        'Plateado',
                      ]"
                      outlined
                      label="Color"
                      placeholder="Color"
                      dense
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.raza"
                      placeholder="Raza"
                      outlined
                      style="width: 120px"
                    />
                  </td> -->

        <!-- Se omplementara el pasto en otro ModalEstablecimiento -->
        <!--  <v-col
                  v-show="
                    isDiagnosticoPecuario(produccion.id_actividad_pecuaria)
                  "
                  cols="6"
                  md="4"
                >
                  <v-text-field
                    v-model.number="produccion.haespecia"
                    :rules="[r.float, r.min_num(0.1), r.max_num(10000000)]"
                    label="Superficie para pasto"
                    suffix="Ha"
                    outlined
                  />
                </v-col> 
                  <td>
                    <span>{{ item.ugsumespecie }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
         <v-snackbar v-model="snackbarVisible" color="error" timeout="3000">
        {{ snackbarMessage }}
        <v-btn color="white" text @click="snackbarVisible = false"
          >Cerrar</v-btn
        >
        </v-snackbar>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>-->
        <!-- FALTA <v-col v-if="pastoSurfaceOverflow" cols="12">
          <n-text error :fix-required="pastoSurfaceOverflow"
            >La superficie acumulada del pasto en la producción excede la
            superficie para pasto que coloco.</n-text
          >
        </v-col> -->
        <!--          <v-col
            v-if="!isDiagnosticoPecuario(produccion.id_actividad_pecuaria)"
            cols="6"
            md="2"
          >
            <v-text-field
              v-model.number="produccion.cantidad"
              :rules="[r.float, r.min_num(0), r.max_num(10000000)]"
              label="Cantidad"
              suffix="#"
              outlined
            />
          </v-col>
          <v-col cols="6" md="2">
            <v-text-field
              disabled
              :value="produccion.ugsumespecie"
              :rules="[r.required, r.float, r.min_num(0), r.max_num(10000000)]"
              label="ug"
              outlined
            />
          </v-col> -->

        <!-- Tabla de Engorde - Avances creados desde Producciones -->
        <!--  <v-row v-if="mostrarEngorde" justify="center" class="mx-0">
        <v-col cols="12" class="px-0">
          <div class="text-h5 font-weight-bold">Etapas y Engorde</div>
          <div class="text-h6 black--text">
            Agregue el engorde (peso) de cada animal o del grupo y cada etapa de
            producción
          </div>
        </v-col> 
        <v-col cols="12" class="px-0">
          <div class="text-h6 black--text">
            Agregue el engorde (peso) de cada animal o del grupo y cada etapa de
            producción
          </div>
        </v-col> 

        <v-col cols="12">
          <div
            style="
              overflow-x: auto;
              overflow-y: auto;
              max-height: 400px;
              width: 100%;
              border: 1px solid #ccc;
            "
          >
            <table class="custom-table1">
              <thead>
                <tr>
                  <th v-for="headera in headers_engorde" :key="headera.value">
                    {{ headera.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(fila, index) in registro.engorde" :key="index">
                  <td>
                    <v-autocomplete
                      v-model="fila.id_actividad_pecuaria"
                      :items="actividad_pecuaria"
                      item-text="descripcion"
                      item-value="id"
                      label="Tipo de Animal*"
                      style="width: 200px"
                    />
                  </td>

                  <td>
                    <v-text-field v-model="fila.identirubro" outlined />
                  </td>

                  <td>
                    <v-text-field
                      v-model="fila.fecha_medicion"
                      type="date"
                      outlined
                    />
                  </td>

                  <td>
                    <v-select
                      v-model="fila.etapa_anterior"
                      :items="estado_pecuario"
                      item-text="estado_productivo"
                      item-value="estado_productivo"
                      outlined
                    />
                  </td>

                  <td>
                    <v-select
                      v-model="fila.etapa_actual"
                      :items="estado_pecuario"
                      item-text="estado_productivo"
                      item-value="estado_productivo"
                      outlined
                    />
                  </td>

                  <td>
                    <v-text-field
                      v-model="fila.cantidad"
                      label="Cantidad"
                      style="width: 100px"
                      outlined
                    />
                  </td>

                  <td>
                    <v-text-field
                      v-model="fila.medicion"
                      label="Peso"
                      style="width: 100px"
                      outlined
                    />
                  </td>

                  <td>
                    <v-select
                      v-model="fila.unidad"
                      :items="unidad_medida"
                      item-text="descripcion"
                      item-value="id"
                      label="Unidad"
                      style="width: 100px"
                      outlined
                    />
                  </td>

                  <td>
                    <v-btn icon @click="eliminarFila(index)">
                      <v-icon color="red">mdi-close</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
      
        <tr class="button-row">
        <td colspan="100%">
          <v-btn
            depressed
            block
            class="primary--text custom-button"
            style="margin-top: 10px"
            @click="handleAddRowAndOtherAction()"
          >
            <v-icon left>mdi-plus</v-icon>
            Agregar Engorde
          </v-btn>
        </td>
        </tr>
        </v-row> -->
        <!--  </v-col> -->
        <!-- <button
                    @click="handleAddRowAndOtherAction()"
                    class="btn btn-primary"
                  >
                    Agregar Engorde
            </button> -->
        <!-- </v-row> -->
        <!-- listado dinámico de destinos -->
        <!--  <v-col cols="12">
          <div class="text-h6">VENTAS Y CÁLCULOS DE COMPETITIVIDAD</div>
        </v-col> -->
        <!-- Tabla de Engorde - Avances creados desde Producciones -->
        <v-row v-if="mostrarEngorde" class="mx-0">
          <!-- Botón Agregar engorde -->
          <v-col cols="4">
            <v-btn
              block
              rounded
              class="primary--text custom-button"
              @click="handleAddRowAndOtherAction()"
            >
              <v-icon left>mdi-plus</v-icon>
              Agrega Engorde
            </v-btn>
          </v-col>
          <!-- AQUI Formulario engorde -->
          <v-col cols="12" v-if="indexEdicionEngorde !== null">
            <v-card outlined class="pa-4 mb-4">
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="
                      registro.engorde[indexEdicionEngorde].fecha_medicion
                    "
                    placeholder="aaaa-mm-dd"
                    :rules="[r.required]"
                    label="Fecha que ocurre *"
                    outlined
                    ref="fechaocurree"
                    @change="validarFecha"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="
                      registro.engorde[indexEdicionEngorde]
                        .id_actividad_pecuaria
                    "
                    :rules="[r.required]"
                    :items="actividad_pecuaria"
                    item-text="descripcion"
                    item-value="id"
                    label="Tipo de Ganado *"
                    outlined
                  />
                </v-col>
                <!--  <v-col cols="12">
                  <div class="d-flex justify-end">
                    <modal-ingreso
                      @nuevo-registro="agregarRegistroDesdeModal"
                    />
                  </div>
                </v-col> -->

                <v-col cols="12" md="3">
                  <v-combobox
                    v-model="registro.engorde[indexEdicionEngorde].identirubro"
                    label="Identificación de Ganado *"
                    outlined
                    :rules="[r.required]"
                    :items="IdentirubroSugeridosEngorde"
                  />
                </v-col>
                <!-- <v-col cols="12" md="3">
                  <v-select
                  v-model="registro.engorde[indexEdicionEngorde].etapa_anterior"
                  :items="estado_pecuario"
                  item-text="estado_productivo"
                  item-value="estado_productivo"
                  label="Etapa Productiva Anterior"
                  outlined
                  />
                </v-col> -->
                <!-- <v-col cols="12" md="3">
                  <v-select
                  v-model="registro.engorde[indexEdicionEngorde].etapa_actual"
                  :items="estado_pecuario"
                  item-text="estado_productivo"
                  item-value="estado_productivo"
                  label="Etapa Productiva Actual"
                  outlined
                  />
                </v-col> -->
                <!-- <v-col cols="12" md="3">
                  <v-text-field
                  v-model.number="registro.engorde[indexEdicionEngorde].cantidad"
                  label="Cantidad"
                  outlined
                  />
                </v-col> -->
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model.number="
                      registro.engorde[indexEdicionEngorde].medicion
                    "
                    :rules="[r.required, r.float, r.min_num(0)]"
                    label="Peso *"
                    outlined
                  >
                    <template v-slot:append>
                      <unit-picker
                        @transform="
                          registro.engorde[indexEdicionEngorde].medicion =
                            $event
                        "
                      />
                    </template>
                  </v-text-field>
                </v-col>
                <!--  <v-col cols="6" md="3">
                  <v-select
                    v-model="registro.engorde[indexEdicionEngorde].unidad"
                    :items="unidad_medida"
                    item-text="descripcion"
                    item-value="id"
                    label="Unidad"
                    outlined
                  />
                </v-col> -->
                <v-col cols="6" md="3" class="d-flex align-end">
                  <v-btn color="primary" @click="guardarEngorde">
                    Siguiente
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn icon @click="eliminarFilaEngorde(indexEdicionEngorde)">
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <!-- listado de engorde -->
          <v-col
            cols="12"
            v-for="(fila, index) in registro.engorde"
            :key="index"
          >
            <v-card
              outlined
              class="pa-0 custom-border"
              :style="
                index === indexEdicionEngorde
                  ? 'border: 2.8px solid #ff9800;'
                  : 'border: 2.8px solid #4caf50;'
              "
              @click="editarEngorde(index)"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">
                    <strong>Rubro:</strong>
                    {{ descripcionActividad(fila.id_actividad_pecuaria) || '' }}
                    - Identificación Ganado {{ fila.identirubro || '0' }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Peso: {{ fila.medicion }}
                    {{ descripcionUnidad(fila.unidad) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-right">
                    Fecha: {{ fila.fecha_medicion }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>

        <div v-if="mostrarVenta" style="margin-top: 30px">
          <destino
            :destinos="registro.destinos"
            :producciones="registro.producciones"
            :listado-destinos="destino"
            :rubros="actividad_pecuaria"
            :tabla-produccion-id-rubro="tabla_produccion_id_rubro"
          />
        </div>

        <div v-if="mostrarobserva">
          <v-col cols="12">
            <div class="text-h6">Tareas Pendientes y Observaciones</div>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="registro.observacion"
              :rules="[r.max(1000)]"
              label="Tarea_Pendiente, Fecha, Observación"
              auto-grow
              outlined
              rows="1"
            ></v-textarea>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.number="registro.superficie_para_pasto"
              :rules="[r.required, r.float, () => alertSurfaceOverflow]"
              label="Superficie de pasto *"
              suffix="Ha"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.number="registro.superficie_para_hacerla_pasto"
              :rules="[r.required, r.float, () => alertSurfaceOverflow]"
              label="Superficie para hacerla pasto *"
              suffix="Ha"
              outlined
            ></v-text-field>
          </v-col>
        </div>
        <!-- Campo para ley de beneficio -->
        <!--  <v-col cols="12">
        <v-select
          v-model="registro.ley_beneficio"
          label="Programa"
          :items="programa_gobierno"
          item-text="programa"
          item-value="programa"
          outlined
        />
        </v-col> -->
      </template>

      <v-snackbar v-model="snackbarVisible" color="error">
        {{ snackbarMessage }}
        <v-btn color="white" text @click="snackbarVisible = false"
          >Cerrar</v-btn
        >
      </v-snackbar>
      <!-- </v-row> -->
    </v-form>

    <registro-existente
      :title="'La producción ya existe'"
      :description="'Los datos colocados corresponden a una producción existente, desea cargar la información de esta producción?'"
      :loading="modal_registro_existe_loading"
      :modal="modal_registro_existe"
      @cerrarModal="cerrarModalRegistroExistente"
      @cargarDatos="cargarRegistroExistente"
    />
  </v-container>
</template>

<script>
import debounce from 'lodash.debounce'
import Form from '@/components/js/Form'
import { mapState, mapGetters } from 'vuex'
import { clona } from '../../utilidades'
import {
  produccion_pecuaria,
  formulario_pecuaria,
  danotrx,
  reg_engorde,
} from '../../modelos'
import FincaSelectItem from '../../components/FincaSelectItem.vue'
import ModalParcela from '../../components/ModalParcela.vue'
import ModalIngreso from '../../components/ModalIngreso.vue'
//import ModalEstablecimiento from '../../components/ModalEstablecimiento.vue'
//import SituacionDeDesastre from '../../components/form/SituacionDeDesastre.vue'

export default {
  name: 'Pecuario',
  components: {
    Destino: () => import('@/components/form/Destino.vue'),
    FincaSelectItem,
    ModalParcela,
    ModalIngreso,
    //ModalEstablecimiento,
    //SituacionDeDesastre,
  },
  extends: Form,
  data() {
    return {
      //DRAGON
      activeTab: 'ingreso',
      busquedaFin: false,
      datosCargados: false,
      findeBusqueda: false,
      nuevoPecuario: false,
      registroEncontrado: false,
      mensajeBusqueda: '',
      tipoMensaje: 'info',
      buscandoRegistro: false,
      nuevocoPecuario: false,
      meses: [
        { nombre: 'Enero', valor: 1 },
        { nombre: 'Febrero', valor: 2 },
        { nombre: 'Marzo', valor: 3 },
        { nombre: 'Abril', valor: 4 },
        { nombre: 'Mayo', valor: 5 },
        { nombre: 'Junio', valor: 6 },
        { nombre: 'Julio', valor: 7 },
        { nombre: 'Agosto', valor: 8 },
        { nombre: 'Septiembre', valor: 9 },
        { nombre: 'Octubre', valor: 10 },
        { nombre: 'Noviembre', valor: 11 },
        { nombre: 'Diciembre', valor: 12 },
      ],
      tipoSalidaOptions: [
        { text: 'Al matadero', value: 'Al matadero' },
        { text: 'AutoConsumo', value: 'AutoConsumo' },
        { text: 'Muerte', value: 'Muerte' },
        { text: 'Para comercio', value: 'Para comercio' },
        { text: 'Pérdida', value: 'Pérdida' },
        { text: 'Venta', value: 'Venta' },
        { text: 'Salida hacia otra finca', value: 'Salida hacia otra finca' },
      ],
      criaNacidadOptions: [
        { text: 'Finca', value: 'Finca' },
        { text: 'Comprada', value: 'Comprada' },
      ],
      indexEdicionEngorde: null,
      indexEdicion: null,
      mostrarFormularioEditable: false,
      filaEdicion: null,
      //AQUI
      mostrarInventario: true,
      mostrarProduccion: false,
      mostrarEngorde: false,
      mostrarVenta: false,
      mostrarobserva: false,
      filaVisibleIndex: null,
      color: [
        'Blanco',
        'Negro',
        'Rojo',
        'Café o Marrón',
        'Gris',
        'Rubio o Amarillento',
        'Manchado (negro y blanco)',
        'Overo (rojo y blanco)',
        'Pintado (blanco y marrón o con negro)',
        'Dorado o Bayo',
        'Atigrado (franjas oscuras y claras)',
        'Cintillo Blanco (cara blanca y cuerpo negro)',
        'Plateado',
      ],
      filaEdicion: null,
      //
      llaveid_pecuario: '',
      llaveid_actividad_pecuaria: '',
      llaveidentirubro: '',
      errorin: '',
      errors: {},
      errorn: {},
      errorhas: '',
      fecha: '',
      fecha_fin: '',
      año: '',
      mes: '',
      duracionProduccion: null,
      estaditi: '',
      tabla_principal_id: 'id',
      tabla_produccion_id_rubro: 'id_actividad_pecuaria',
      ruta_registros: 'pecuarios',
      ruta_registro: 'pecuario',
      nombre_registros_en_state: 'pecuarias',
      nombre_registro_en_state: 'pecuario',
      dispatch_get_registro: 'getPecuarias',
      dispatch_guardar_registro: 'guardarPecuaria',
      registro: clona(formulario_pecuaria),
      registro_producciones: clona(produccion_pecuaria),
      engorde: clona(reg_engorde),
      pastoSurfaceOverflow: false,
      filtro: {
        id_actividad_pecuaria: null,
        identirubro: null,
      },

      engorde: [],
      engordeSeleccionado: [],
      identirubroSeleccionado: null, // Mantendrá el identirubro actualmente seleccionado
      idActividadSeleccionada: null, // ID de la actividad seleccionada
      // registrosSeleccionados: [],
      snackbarVisible: false,
      snackbarMessage: '',
      /* engorde: [
        {
          id_actividad_pecuaria: '',
          identirubro: '',
          fecha_medicion: '',
          medicion: '',
          cantidad: 0,
          id_medicion: '',
          unidad: '',
          etapa_anterior: '',
          etapa_actual: '',
        },
      ], */
      headers_produccion: [
        // DRAGON
        { text: 'Ver', value: 'Acción', align: 'center' },
        /////////
        { text: 'Rubro', value: 'id_actividad_pecuaria', align: 'center' },
        { text: 'Codigo trazabilidad', value: 'identirubro', align: 'center' },
        { text: 'Cantidad', value: 'cantidad', align: 'center' },
        { text: 'Produccion*', value: 'produccion', align: 'center' },
        { text: 'Unidad*', value: 'unidad', align: 'center' },
        { text: 'Nacimiento Aproximado', value: 'fechanac', align: 'center' },
        { text: 'Color', value: 'color', align: 'center' },
        { text: 'Raza', value: 'raza', align: 'center' },
        { text: 'UGM', value: 'ugsumespecie', align: 'center' },
        // { text: 'Eliminar Fila', value: 'acciones', align: 'center' },
      ],
      dialogoAbierto: false,
      headers_engorde: [
        { text: 'Rubro', value: 'id_actividad_pecuaria' },
        { text: 'Còdigo de Trazabilidad', value: 'identirubro' },
        { text: 'Fecha que ocurre', value: 'fecha_medicion' },
        { text: 'Etapa Productiva Anterior', value: 'etapa_anterior' },
        { text: 'Etapa Productiva Actual', value: 'etapa_actual' },
        { text: 'Cantidad', value: 'cantidad' },
        { text: 'Peso Total', value: 'medicion' },
        { text: 'Unidad', value: 'unidad' },
        { text: 'Eliminar Fila' },
      ],
      sexoOptions: [
        { text: 'HEMBRA', value: '1' },
        { text: 'MACHO', value: '2' },
        { text: 'N/A', value: null },
      ],
    }
  },

  computed: {
    ...mapGetters('registros', [
      'establecimientosPorId',
      'parcelasPorId',
      'getMatchingRecords',
      'productor_actual',
    ]),
    ...mapState('listados', [
      'actividad_pecuaria',
      'programa_gobierno',
      'estado_pecuario',
      'unidad_medida',
      'tipo_parcela',
    ]),
    ...mapGetters('listados', ['unidadMedidaPorId']),

    años() {
      const añoActual = new Date().getFullYear()
      const años = []

      // Agregar los últimos 10 años en formato "YYYY - YYYY"
      for (let i = 0; i < 10; i++) {
        const añoInicio = añoActual - i
        const añoFin = añoInicio + 1
        años.push({
          texto: `${añoInicio} - ${añoFin}`,
          valor: añoInicio, // o puedes usar un objeto con ambos años
        })
      }

      return años
    },
    sexoTexto() {
      return (sexoValue) => {
        const opcion = this.sexoOptions.find((item) => item.value == sexoValue)
        return opcion ? opcion.text : 'N/A'
      }
    },
    fechasSugeridas() {
      const pecuarias = this.$store.state.registros.pecuarias
      if (!this.registro.id_finca || !this.registro.id_parcela) return []

      if (this.registro.id_finca && !this.registro.id_parcela) {
        const fechas = Object.values(pecuarias)
          .filter(
            (p) => p.id_finca === this.registro.id_finca && p.id_parcela === ''
          )
          .map((p) => p.fecha)

        return [...new Set(fechas)].sort((a, b) => b.localeCompare(a))
      }
      if (this.registro.id_finca && this.registro.id_parcela) {
        const fechas = Object.values(pecuarias)
          .filter(
            (p) =>
              p.id_finca === this.registro.id_finca &&
              p.id_parcela === this.registro.id_parcela
          )
          .map((p) => p.fecha)

        return [...new Set(fechas)].sort((a, b) => b.localeCompare(a))
      }
    },

    IdentirubroSugeridos() {
      const pecuarias = this.$store.state.registros.pecuarias

      if (
        !this.registro.producciones[this.indexEdicion].id_actividad_pecuaria
      ) {
        return []
      }

      const tipoGanadoSeleccionado =
        this.registro.producciones[this.indexEdicion].id_actividad_pecuaria

      if (!pecuarias) {
        return []
      }

      const identirubros = []

      // Recorrer cada registro pecuario
      Object.values(pecuarias).forEach((pecuario) => {
        // Verificar que tenga producciones
        if (pecuario.producciones && Array.isArray(pecuario.producciones)) {
          // Buscar en las producciones de cada pecuario
          pecuario.producciones.forEach((produccion) => {
            if (
              produccion.id_actividad_pecuaria === tipoGanadoSeleccionado &&
              produccion.identirubro &&
              produccion.identirubro.trim() !== ''
            ) {
              identirubros.push(produccion.identirubro)
            }
          })
        }
      })

      return [...new Set(identirubros)].sort((a, b) => a.localeCompare(b))
    },
    IdentirubroSugeridosEngorde() {
      const pecuarias = this.$store.state.registros.pecuarias

      if (
        !this.registro.engorde?.[this.indexEdicionEngorde]
          ?.id_actividad_pecuaria
      ) {
        return []
      }

      const tipoGanadoSeleccionado =
        this.registro.engorde[this.indexEdicionEngorde].id_actividad_pecuaria

      if (!pecuarias) {
        return []
      }

      const identirubros = []

      // Recorrer cada registro pecuario
      Object.values(pecuarias).forEach((pecuario) => {
        // Verificar que tenga producciones
        if (pecuario.producciones && Array.isArray(pecuario.producciones)) {
          // Buscar en las producciones de cada pecuario
          pecuario.producciones.forEach((produccion) => {
            if (
              produccion.id_actividad_pecuaria === tipoGanadoSeleccionado &&
              produccion.identirubro &&
              produccion.identirubro.trim() !== ''
            ) {
              identirubros.push(produccion.identirubro)
            }
          })
        }
      })

      return [...new Set(identirubros)].sort((a, b) => a.localeCompare(b))
    },
    alertSurfaceOverflow() {
      const id = this.registro.id
      const id_finca = this.registro.id_finca
      const year = (date) => new Date(date).getFullYear()
      const pecuarias = this.getMatchingRecords({
        recordName: 'pecuarias',
        matchValues: [
          { key: 'id_finca', value: id_finca },
          { key: 'ciclo', value: this.registro.ciclo },
        ],
        exceptIds: [id],
      })
      const fincas = this.getMatchingRecords({
        recordName: 'fincas',
        matchValues: [{ key: 'id', value: id_finca }],
      })
      const superficies_pecuarias_para_pasto = pecuarias
        .filter((p) => year(p.fecha) === year(this.registro.fecha))
        .map((p) => p.superficie_para_pasto)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
      const superficies_pecuarias_para_hacerlas_pasto = pecuarias
        .filter((p) => year(p.fecha) === year(this.registro.fecha))
        .map((p) => p.superficie_para_hacerla_pasto)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
      const overflow =
        superficies_pecuarias_para_pasto +
          superficies_pecuarias_para_hacerlas_pasto +
          parseFloat(this.registro.superficie_para_pasto) +
          parseFloat(this.registro.superficie_para_hacerla_pasto) >
        parseFloat(fincas?.[0]?.extension ?? 0)
      return (
        !overflow ||
        'La suma de las superficies para este año, ciclo y finca exceden la superficie de la finca'
      )
    },
  },

  watch: {
    //  Observar la fecha de finalización para calcular la duración automáticamente
    //'registro.fecha_fin': 'calcularDuracionProduccion',

    /*  producciones: {
      handler(newProducciones) {
        if (newProducciones && newProducciones.length > 0) {
          // EN ENGORDE Filtra las filas vacías que no tienen un id_actividad_pecuaria
          const filasVacias = this.registro.engorde.filter(
            (fila) => !fila.id_actividad_pecuaria
          )

          newProducciones.forEach((produccion) => {
            
            const filaVacia = filasVacias.shift() // Toma la primera fila vacía disponible

            if (filaVacia) {
              // Verifica que la fila tiene los datos necesarios antes de asignar los valores
              if (produccion.id_actividad_pecuaria) {
                // Actualiza la fila vacía con los datos de la nueva producción
                Object.assign(filaVacia, {
                  identirubro: produccion.identirubro || '0',
                  fecha_medicion:
                    produccion.fecha_medicion ||
                    new Date().toISOString().split('T')[0],
                  etapa_anterior: produccion.etapa_anterior || '',
                  etapa_actual: produccion.etapa_actual || '',
                  cantidad: produccion.cantidad || 0,
                  medicion: produccion.medicion || '',
                  id_medicion: produccion.id_medicion || '',
                  id_pecuario: produccion.id_pecuario || null,
                  id_actividad_pecuaria:
                    produccion.id_actividad_pecuaria || null,
                  ingreso_anual: produccion.ingreso_anual || 0,
                })
              } else {
                // Si no hay id_actividad_pecuaria, elimina la fila vacía para evitar errores
                const index = this.registro.engorde.indexOf(filaVacia)
                if (index > 0) {
                  this.registro.engorde.splice(index, 1)
                }
              }
            }
          })
        }
      },
    }, */

    /* 'registro.superficie_para_pasto': {
      immediate: true,
      handler() {
        this.calculatePastoSurfaceAndWarn()
      },
    }, */

    'registro.producciones': {
      deep: true,
      immediate: true,
      handler() {
        this.convertirDatosSexo()
        this.calculatePastoSurfaceAndWarn()

        for (const [index, prod] of this.registro?.producciones?.entries()) {
          // calcula el ug para cada elemento de producción
          const isDiagnosticoPecuario = this.isDiagnosticoPecuario(
            prod.id_actividad_pecuaria
          )
          const rubro = this.getRubroById(prod.id_actividad_pecuaria)
          if (!rubro) {
            return ''
          }

          /*  if (isDiagnosticoPecuario) {
            if (!isNaN(prod.haespecia) && !isNaN(rubro.ugequivalente)) {
              this.registro.producciones[index].ugsumespecie = (
                prod.haespecia * rubro.ugequivalente
              ).toFixed(2)
            } else {
              this.registro.producciones[index].ugsumespecie = 0
            }
          } else {
            if (!isNaN(prod.cantidad) && !isNaN(rubro.ugequivalente)) {
              this.registro.producciones[index].ugsumespecie = (
                prod.cantidad * rubro.ugequivalente
              ).toFixed(2)
            } else {
              this.registro.producciones[index].ugsumespecie = 0
            }
          } */
        }
      },
    },
  },

  mounted() {
    this.$store.commit('ui/updateToolbar', 'Pecuario')
    const id = this.obtenerIdDeRuta()
    this.registro.id_productor = this.productor_actual
    if (id) {
      this.cargarRegistro(id)
      this.activarEdicionSiCoincide()
      this.busquedaFin = true
      /* this.registro.fecha = this.formatearFechaParaFormulario(
        this.registro.fecha
      ) */
      //aqui para que tenga un registro "ingreso" siempre que se cargue el registro
      //this.agregarProduccionYEditar()
      //this.AgregarEngorde()
    } else {
      this.registro = clona(formulario_pecuaria)
      // Limpiar el arreglo de producciones
      //this.registro.producciones = []
      this.busquedaFin = false
      //AQUI
      //this.agregarProduccionYEditar()
      //this.registro.engorde = []
      //this.AgregarEngorde()
    }

    this.registro.id_productor = this.productor_actual

    // Establece la fecha de inicio al cargar la página
    //this.setFechaInicio()
    //this.inicializarProducciones()
    if (!this.registro.ciclo) {
      this.registro.ciclo = 1
    }
  },

  methods: {
    agregarRegistroDesdeModal(registroNuevo) {
      registroNuevo.id = uuidv4()
      this.producciones.unshift(registroNuevo)
    },
    cantidad_vendida_inversa() {
      let produccion = this.registro.produccion
      let vendido = this.registro.cantidad_vendida
      if (this.registro.unidad_produccion === 'lb') {
        produccion = produccion * this.lb_to_kg
      }
      if (this.registro.unidad_cantidad_vendida === 'lb') {
        vendido = vendido * this.lb_to_kg
      }
      return vendido > produccion
    },
    crearNuevoGanado() {
      this.$router.push('/ru/ingreso')
    },

    activarEdicionSiCoincide() {
      const identi = localStorage.getItem('identirubroBuscado')
      if (!identi || !this.registro?.producciones) return

      const index = this.registro.producciones.findIndex(
        (prod) => prod.identirubro === identi
      )
      if (index !== -1) {
        this.indexEdicion = index
      }
      localStorage.removeItem('identirubroBuscado')
    },
    registroNoEncontrado() {
      this.mensajeBusqueda =
        'Muy bien! este registro aún No existe, Vamos, continua llenandolo.'
      this.tipoMensaje = 'info'
      this.nuevoPecuario = true
      this.crearNuevoRegistro()
    },
    async crearNuevoRegistro() {
      const { id_finca, id_parcela, fecha } = this.registro

      if (this.$route.path !== '/ru/pecuario') {
        await this.$router.push('/ru/pecuario')
      }
      this.registro = clona(formulario_pecuaria)

      this.registro.id_productor = this.productor_actual
      this.registro.id_finca = id_finca
      this.registro.id_parcela = id_parcela
      this.registro.fecha = fecha
      // Agregar formulario inicial
      this.registro.producciones = [clona(this.registro_produccion)]
      this.indexEdicion = 0 // formulario abierto por default
      this.busquedaFin = true
    },

    onFincaChange() {
      if (this.busquedaFin) return
      // Ejecutar la función original para cargar fincas/parcelas disponibles
      this.debounceBuscarRegistroExistente()
      // Ejecutar la función para buscar registro
      this.debounceBuscarRegistroPorCriterios()
    },

    onParcelaChange() {
      if (this.busquedaFin) return
      // Ejecutar la función original para cargar fincas/parcelas disponibles
      this.debounceBuscarRegistroExistente()
      // Ejecutar nuestra función para buscar registro por criterios
      this.debounceBuscarRegistroPorCriterios()
    },

    async onFechaChange() {
      // 1) Forzar que el texto escrito quede en el modelo antes de validar
      const cb = this.$refs.fechaInicio
      if (
        cb &&
        cb.internalSearch != null &&
        cb.internalSearch !== this.registro.fecha
      ) {
        this.registro.fecha = cb.internalSearch.trim()
      }
      await this.$nextTick() // espera a que Vue actualice

      // 2) Validar con el valor ya actualizado
      const camposValidos =
        this.$refs.fincaSelect.validate() &&
        this.$refs.parcelaSelect.validate() &&
        this.$refs.fechaInicio.validate()

      if (!camposValidos) {
        this.$store.commit('ui/setSnack', {
          text: 'Debe llenar Finca, Parcela y Fecha antes de continuar',
          color: 'error',
        })
        return
      }

      if (!this.validarFecha()) {
        return
      }

      if (this.busquedaFin) return

      // Ejecutar función para buscar registro por criterios
      this.debounceBuscarRegistroPorCriterios()
    },
    onLupaChange() {
      if (this.busquedaFin) return
      // Ejecutar función para buscar registro por criterios
      this.debounceBuscarRegistroPorCriterios()
    },

    debounceBuscarRegistroPorCriterios: debounce(async function () {
      await this.buscarRegistroPorCriterios()
    }, 1000),

    async buscarRegistroPorCriterios() {
      // Si la búsqueda inicial ya se completó, no hagas nada más.
      if (this.busquedaFin) {
        return
      }

      if (!this.registro.id_finca || !this.registro.fecha) {
        this.limpiarMensaje()
        return
      }
      this.buscandoRegistro = true
      this.limpiarMensaje()
      try {
        const registroExistente = this.buscarRegistroLocal()
        if (registroExistente) {
          await this.traerRegistroYNavegar(registroExistente)
        } else {
          // Si no está en local, buscar en servidor
          await this.buscarRegistroEnServidor()
        }
      } catch (error) {
        this.registroNoEncontrado()
      } finally {
        this.buscandoRegistro = false
        this.busquedaFin = true
      }
    },
    buscarRegistroLocal() {
      // anabel dice hay q verlo Buscar en el store de forestales
      const pecuarias = this.$store.state.registros.pecuarias
      return Object.values(pecuarias).find(
        (pecuaria) =>
          pecuaria.id_finca === this.registro.id_finca &&
          pecuaria.id_parcela === this.registro.id_parcela &&
          pecuaria.fecha === this.registro.fecha
      )
    },
    async buscarRegistroEnServidor() {
      try {
        const response = await this.$store.dispatch(
          'registros/listarPecuariasx',
          {
            id_productor: this.productor_actual,
            id_finca: this.registro.id_finca,
            id_parcela: this.registro.id_parcela,
            fecha: this.registro.fecha,
          }
        )

        if (response && response.success && Array.isArray(response.data)) {
          const fechaBuscada = this.registro.fecha
          const registroExacto = response.data.find((r) => {
            const fechaApi = r.fecha ? r.fecha.split('T')[0] : null
            return fechaApi === fechaBuscada
          })

          if (registroExacto) {
            await this.traerRegistroYNavegar(registroExacto)
          } else {
            this.registroNoEncontrado()
          }
        } else {
          this.registroNoEncontrado()
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.registroNoEncontrado()
        } else {
          throw error
        }
      }
    },

    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getPecuaria', { id: registro.id })
      }
      this.$router.push(`/ru/pecuario/${registro.id}`)
      this.esEditable = false
      this.busquedaFin = true
    },

    mostrarMensaje(mensaje, tipo) {
      this.mensajeBusqueda = mensaje
      this.tipoMensaje = tipo
    },

    limpiarMensaje() {
      this.mensajeBusqueda = ''
      this.tipoMensaje = 'info'
    },
    descripcionActividad(id) {
      const act = this.actividad_pecuaria.find((a) => a.id === id)
      return act ? act.descripcion : 'Desconocido'
    },
    convertirDatosSexo() {
      if (this.registro.producciones) {
        this.registro.producciones.forEach((produccion) => {
          // Convertir número a string para que coincida con los values del select
          if (produccion.sexo !== null && produccion.sexo !== undefined) {
            produccion.sexo = produccion.sexo.toString()
          }
        })
      }
    },
    agregarProduccionYEditar() {
      this.registro.producciones.unshift(clona(this.registro_produccion))
      this.registro.id_productor = this.productor_actual
      this.indexEdicion = 0
      this.$nextTick(() => {
        if (this.$refs.tipoGanadoSelect && this.$refs.tipoGanadoSelect.focus) {
          this.$refs.tipoGanadoSelect.focus()
        }
      })
    },
    pmostrarIngreso() {
      this.mostrarInventario = true
      this.mostrarEngorde = false
      this.mostrarVenta = false
      this.activeTab = 'ingreso'
    },
    pmostrarEngorde() {
      this.mostrarInventario = false
      this.mostrarEngorde = true
      this.mostrarVenta = false
      this.activeTab = 'engorde'
    },
    pmostrarVenta() {
      this.mostrarInventario = false
      this.mostrarEngorde = false
      this.mostrarVenta = true
      this.activeTab = 'venta'
    },
    editarProduccion(index) {
      this.indexEdicion = index
    },

    guardarEntrada() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('ui/setSnack', {
          text: 'Verifique los elementos en rojo',
          color: 'error',
        })
        return ''
      }
      this.indexEdicion = null
    },
    //////////   DRAGON ///////////////
    mostrarFormularioEdicion(index) {
      const item = this.registro.producciones[index]
      // Hacemos una copia editable para no afectar en tiempo real la tabla
      this.filaEdicion = { ...item }
      this.filaVisibleIndex = index
      this.mostrarFormularioEditable = true
    },
    ocultarFormulario() {
      // DRAGON Guarda los cambios en la tabla original
      if (this.filaVisibleIndex !== null) {
        this.$set(this.registro.producciones, this.filaVisibleIndex, {
          ...this.filaEdicion,
        })
      }
      this.filaVisibleIndex = null
      this.mostrarFormularioEditable = false
      this.filaEdicion = null
    },
    /////////////////////
    aplicarFiltro(produccion) {
      // Actualiza los criterios de filtro
      this.filtro.id_actividad_pecuaria = produccion.id_actividad_pecuaria
      this.filtro.identirubro = produccion.identirubro
    },
    limpiarDestinosYGuardar() {
      // Verificar si algún destino tiene el campo 'rubro' vacío
      const destinosConRubroVacio = this.registro.destinos.filter(
        (destino) => !destino.rubro
      )
      // Si hay destinos con el campo 'rubro' vacío
      if (destinosConRubroVacio.length > 0) {
        // Mostrar una alerta (por ejemplo con v-snackbar o alert, dependiendo de lo que prefieras)
        this.snackbarMessage =
          'Es requerido cerrar la venta si no se está incluyendo venta válida.'
        this.snackbarVisible = true
      } else {
        // Filtrar destinos con rubro lleno
        this.registro.destinos = this.registro.destinos.filter(
          (destino) => destino.rubro
        )
      }
      //console.log('Registro limpio:', this.registro)
    },

    inicializarProducciones() {
      if (this.registro.producciones.length < 1) {
        while (this.registro.producciones.length < 1) {
          this.addRow()
        }
      }

      if (this.registro.engorde.length < 1) {
        while (this.registro.engorde.length < 1) {
          this.AgregarEngorde()
        }
      }
      // Asegurar que todos los registros tengan datos o asignarlos vacios si no existen
      this.registro.producciones = this.registro.producciones.map(
        (produccion) => ({
          ...produccion,
          costo_inicial:
            typeof produccion.costo_inicial !== 'undefined'
              ? produccion.costo_inicial
              : '0',
          estatus: produccion.estatus || 'A',
          identirubro: produccion.identirubro || '0',
          haespecia: produccion.haespecia || '',
          //ugequivalente: produccion.ugequivalente || '',
          unidad: produccion.unidad || '',
        })
      )
    },
    addRow() {
      this.registro.producciones.push({
        id_actividad_pecuaria: '',
        identirubro: '',
        fechanac: '',
        color: '',
        raza: '',
        cantidad: '',
        peso_inicial: '0',
        ugsumespecie: '',
        costo_inicial: 0,
        unidad: '',
        //ugequivalente: '',
        estatus: 'A',
      })
    },
    AgregarEngorde() {
      const nuevoEngorde = {
        id_actividad_pecuaria: null,
        identirubro: '0',
        fecha_medicion: new Date().toISOString().substr(0, 10),
        etapa_anterior: null,
        etapa_actual: null,
        cantidad: null,
        medicion: null,
        unidad: null,
      }
      this.registro.engorde.unshift(nuevoEngorde)
      this.indexEdicionEngorde = 0
      this.$nextTick(() => {
        if (this.$refs.fechaocurree && this.$refs.fechaocurree.focus) {
          this.$refs.fechaocurree.focus()
        }
      })
    },
    editarEngorde(index) {
      this.indexEdicionEngorde = index
    },
    guardarEngorde() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('ui/setSnack', {
          text: 'Verifique los elementos en rojo',
          color: 'error',
        })
        return ''
      }
      this.indexEdicionEngorde = null
    },

    esEngordeValido(fila) {
      return (
        fila.id_actividad_pecuaria && fila.identirubro && fila.fecha_medicion
      )
    },

    esEntradaValida(item) {
      return item.id_actividad_pecuaria
    },

    esDestinoValido(destino) {
      return destino.rubro
    },

    descripcionUnidad(idUnidad) {
      const unidad = this.unidad_medida.find((u) => u.id === idUnidad)
      return unidad ? unidad.descripcion : ''
    },

    handleAddRowAndOtherAction() {
      this.AgregarEngorde()
    },

    /*     handleFechaChange() {
      this.validarFecha() // Validar la fecha de inicio
      this.validarFechahas() // Validar la fecha de fin
      if (this.registro.fecha && this.registro.fecha_fin) {
        this.debounceBuscarRegistroExistente()
        this.calcularDuracionProduccion()
      }
    }, */

    setFechaInicio() {
      const today = new Date()
      const dia = today.getDate().toString().padStart(2, '0')
      const mes = (today.getMonth() + 1).toString().padStart(2, '0') // getMonth() es 0-indexado
      const anio = today.getFullYear()
      this.registro.fecha = `${dia}-${mes}-${anio}`
    },

    validarFecha() {
      const regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/ // formato aaaa-mm-dd
      const fecha = this.registro.fecha

      if (!regexFecha.test(fecha)) {
        this.errorin =
          'Favor colocar la fecha en el formato correcto: aaaa-mm-dd'
        return false
      }

      const [, anio, mes, dia] = fecha.match(regexFecha)
      const diaInt = parseInt(dia, 10)
      const mesInt = parseInt(mes, 10)
      const anioInt = parseInt(anio, 10)

      if (mesInt < 1 || mesInt > 12) {
        this.errorin = 'El mes debe estar en el rango de 1 a 12.'
        return false
      }

      const diasEnMes = new Date(anioInt, mesInt, 0).getDate()
      if (diaInt < 1 || diaInt > diasEnMes) {
        this.errorin = `El día no es válido para el mes ${mesInt} y año ${anioInt}.`
        return false
      }

      this.errorin = '' // Todo bien
      return true
    },

    validarFechaNac() {
      const fechaNac = this.registro.producciones[this.indexEdicion].fechanac
      const claveError = `fechanac_${this.indexEdicion}`

      if (!fechaNac) {
        this.$set(this.errorn, claveError, '')
        return true
      }

      // Validar formato aaaa-mm-dd
      const regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!regexFecha.test(fechaNac)) {
        this.$set(
          this.errorn,
          claveError,
          'Formato incorrecto. Use aaaa-mm-dd (ej: 2025-08-04)'
        )
        return false
      }

      const [, anio, mes, dia] = fechaNac.match(regexFecha)
      const diaInt = parseInt(dia, 10)
      const mesInt = parseInt(mes, 10)
      const anioInt = parseInt(anio, 10)

      // Validación básica de rangos
      if (mesInt < 1 || mesInt > 12) {
        this.$set(this.errorn, claveError, 'El mes debe estar entre 1 y 12.')
        return false
      }

      const diasEnMes = new Date(anioInt, mesInt, 0).getDate()
      if (diaInt < 1 || diaInt > diasEnMes) {
        this.$set(this.errorn, claveError, `El día no es válido para el mes.`)
        return false
      }

      // Validación exitosa
      this.$set(this.errorn, claveError, '')
      return true
    },
    validarFechaSalida(index) {
      const fechaSalida = this.registro.producciones[index].salida

      // Si está vacío, borra errores y no valida
      if (!fechaSalida) {
        this.$set(this.errors, `salida_${index}`, [])
        return true
      }

      // Expresión regular para validar el formato aaaa-mm-dd
      const regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/

      if (!regexFecha.test(fechaSalida)) {
        this.$set(this.errors, `salida_${index}`, [
          'Formato inválido. Usa aaaa-mm-dd',
        ])
        return false
      }

      const [, anio, mes, dia] = fechaSalida.match(regexFecha)
      const diaInt = parseInt(dia, 10)
      const mesInt = parseInt(mes, 10)
      const anioInt = parseInt(anio, 10)

      if (mesInt < 1 || mesInt > 12) {
        this.$set(this.errors, `salida_${index}`, [
          'El mes debe estar entre 01 y 12',
        ])
        return false
      }

      const diasEnMes = new Date(anioInt, mesInt, 0).getDate()
      if (diaInt < 1 || diaInt > diasEnMes) {
        this.$set(this.errors, `salida_${index}`, [
          `El día no es válido para el mes ${mesInt}`,
        ])
        return false
      }

      this.$set(this.errors, `salida_${index}`, [])
      return true
    },
    //función que formatea la fecha para enviarla a la BD
    formatearFechaParaBD(fechaDDMMYYYY) {
      const regex = /^(\d{2})-(\d{2})-(\d{4})$/
      if (!regex.test(fechaDDMMYYYY)) return fechaDDMMYYYY
      const [, dia, mes, anio] = fechaDDMMYYYY.match(regex)
      return `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    //Función que formatea la fecha que que se trae de la BD para mostrarla en el front
    formatearFechaParaFormulario(fechaYYYYMMDD) {
      const regex = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!regex.test(fechaYYYYMMDD)) return fechaYYYYMMDD
      const [, anio, mes, dia] = fechaYYYYMMDD.match(regex)
      return `${dia}-${mes}-${anio}`
    },
    //funcion para limpiar los array vacios antes de guardar
    limpiarRegistrosVacios() {
      this.registro.producciones = this.registro.producciones.filter((item) =>
        this.esEntradaValida(item)
      )
      this.registro.engorde = this.registro.engorde.filter((item) =>
        this.esEngordeValido(item)
      )
      this.registro.destinos = (this.registro.destinos || []).filter((item) =>
        this.esDestinoValido(item)
      )
      this.$nextTick(() => {})
    },

    async antesDeGuardar() {
      const payload = { ...this.registro }

      if (!payload.id_finca || !payload.id_parcela || !payload.fecha) {
        this.$store.commit('ui/setSnack', {
          text: 'Antes de guardar debe llenar Finca, Parcela y Fecha antes de guardar',
          color: 'error',
        })
        return
      }

      // Limpiar registros vacíos
      this.limpiarRegistrosVacios()
      //Esperar a que termine la limpieza
      await this.$nextTick()
      // Formatear fechas
      /* this.registro.fecha = this.formatearFechaParaBD(this.registro.fecha)
      this.registro.producciones.forEach((produccion, index) => {
        produccion.salida = this.formatearFechaParaBD(produccion.salida)
        produccion.fechanac = this.formatearFechaParaBD(produccion.fechanac)
      })
      await this.$nextTick() */
      //  Evitar navegación redundante
      if (this.$route.path === `/ru/${this.ruta_registros}`) {
        this.ruta_registros = ''
      }
      await this.guardarYContinuar()

      if (this.registro.producciones && this.registro.producciones.length) {
        const promesasInventario = this.registro.producciones.map((prod) => {
          const inventarioPayload = {
            ...prod,
            id_productor: this.registro.id_productor,
            id_finca: this.registro.id_finca,
            created_at: new Date().getTime() / 1000,
          }
          return this.$store.dispatch(
            'registros/guardarInventario',
            inventarioPayload
          )
        })

        const resultados = await Promise.all(promesasInventario)
      } else {
      }
    },
    calcularDuracionProduccion() {
      const fecha = new Date(this.registro.fecha)
      const fecha_fin = new Date(this.registro.fecha_fin)

      if (!isNaN(fecha) && !isNaN(fecha_fin)) {
        const aniosDiferencia = fecha_fin.getFullYear() - fecha.getFullYear()
        const mesesDiferencia = fecha_fin.getMonth() - fecha.getMonth()
        this.registro.duracionProduccion =
          aniosDiferencia * 12 + mesesDiferencia
      } else {
        this.registro.duracionProduccion = 0 // Si alguna fecha no es válida, asigna 0
      }
    },

    // retorna true si es Diagnostico pecuario
    isDiagnosticoPecuario(id_cultivo) {
      return (
        this.getRubroById(id_cultivo)?.clasificacion === 'ADIAGNOSTICO PECUARIO'
      )
    },

    //no se usa
    getRubroById(id_cultivo) {
      return this.actividad_pecuaria.find((ap) => ap.id === id_cultivo)
    },

    calculatePastoSurfaceAndWarn() {
      let surfaceSum = 0
      for (const prod of this.registro?.producciones) {
        // calcula que la suma de superfices no exceda la del formulario
        if (!isNaN(parseFloat(prod.haespecia)) && prod.haespecia > 0) {
          surfaceSum += parseFloat(prod.haespecia)
        }

        this.pastoSurfaceOverflow =
          surfaceSum > this.registro.superficie_para_pasto ? true : false
      }
    },

    guessUnit(id_rubro) {
      const rubro = this.actividad_pecuaria.find((a) => a.id === id_rubro)
      return this.unidadMedidaPorId(rubro?.id_unidad_medida ?? 2)
    },

    handleActividadChange(indice) {
      if (indice === undefined || indice === null) return

      const rubro = this.actividad_pecuaria.find(
        (a) => a.id === this.registro.producciones[indice].id_actividad_pecuaria
      )

      if (this.registro.producciones[indice].id_actividad_pecuaria) {
        if (!this.registro.producciones[indice].identirubro) {
          this.registro.producciones[indice].identirubro = '0'
        }

        this.registro.producciones[indice].unidad =
          rubro?.id_unidad_medida ?? null
        //this.registro.producciones[indice].ugequivalente = 0
        this.registro.producciones[indice].ugsumespecie = 0
        this.registro.producciones[indice].produccion = 0
        this.registro.producciones[indice].cantidad = 1
        this.registro.producciones[indice].haespecia = 0
        this.registro.producciones[indice].costo_inicial = 0
        this.registro.producciones[indice].peso_inicial = 0
        this.registro.producciones[indice].estatus = 'A'
      }
    },
    async obtenerUnRegistroONada() {
      try {
        const id_productor = this.registro.id_productor
        const ciclo = this.registro.ciclo
        const fecha = this.registro.fecha
        const id_finca = this.registro.id_finca
        const id_parcela = this.registro.id_parcela

        const id_rubros = !this.obtenerIdDeRuta()
          ? this.registro.producciones
              .filter((prod) => !!prod.id_actividad_pecuaria)
              .map((prod) => prod.id_actividad_pecuaria)
          : []

        if (id_rubros.length === 0) {
          id_rubros = []
        }

        const rubros =
          (!this.obtenerIdDeRuta() && id_rubros.length > 0) ||
          this.obtenerIdDeRuta()

        // required fields to be fulfilled
        if (id_productor && ciclo && fecha && id_finca && rubros) {
          const { status, data } = await this.$store.dispatch(
            'registros/listarPecuariasx',
            {
              id_productor,
              ciclo,
              fecha,
              id_finca,
              id_parcela,
              id_rubros,
            }
          )
          if (status === 'ok' && data.length > 0) return data[0]
        }
        return {}
      } catch (e) {
        return {}
      }
    },
    Cancelar() {
      this.$router.push('/ru/pecuarios')
    },
    agregarDesastre() {
      this.registro.desastres?.push({ ...danotrx })
    },
    eliminarDesastre(index) {
      this.registro.desastres?.splice(index, 1)
    },
    eliminarFilaProduccion(index) {
      this.registro.producciones.splice(index, 1)
      if (this.indexEdicion === index) {
        this.indexEdicion = null
      } else if (this.indexEdicion > index) {
        this.indexEdicion--
      }
    },
    eliminarFilaEngorde(index) {
      this.registro.engorde.splice(index, 1)
      this.indexEdicionEngorde = null
    },
  },
}
</script>
<style scoped>
/* .overflow-container {
  overflow-x: auto;
  width: 100%;
  margin: 0 auto;
  /* max-width: 100%;
} */
.btn-oval {
  border-radius: 50px; /* Hace que el botón sea más ovalado */
}
.btn-final {
  display: flex;
}
.cancel {
  background-color: red !important;
  color: white !important;
}

.error-text {
  color: red;
  font-size: 0.875rem;
}

.button-row td {
  border: none;
  padding: 0;
  text-align: center;
}

.button-row {
  margin: 16px 0;
  /* Agrega espacio alrededor */
}

.custom-table {
  min-width: 500px;
  width: 100%;
  border-collapse: collapse;
}

.custom-table th,
.custom-table td {
  padding: 8px;
  text-align: left;
  border: 1px solid #ccc;
}

.custom-table th.header {
  font-size: 15px;
}
.custom-table th {
  background-color: #050505ef;
  text-align: center;
  color: #fff;
}

.custom-table1 {
  min-width: 500px;
  width: 100%;
  border-collapse: collapse;
}

.custom-table1 th,
.custom-table1 td {
  text-align: center;
  border: 1px solid #ccc;
  padding: 8px;
}

@media (max-width: 768px) {
  .custom-table1 th,
  .custom-table1 td {
    font-size: 12px; /* Reducir tamaño de fuente */
  }
}

.custom-table1 th.headera {
  font-size: 15px;
}

.custom-table1 th {
  background-color: #050505ef;
  text-align: center;
  color: #fff;
}

.table-container {
  overflow-y: auto;
  overflow-x: auto;
  width: 100%;
  height: auto;
}

.elevation-1 {
  max-width: 100%;
  /* Asegura que el contenedor de la tabla se expanda completamente */
  /* overflow-x: auto; */
  /* Permite que la tabla sea desplazable si es más ancha que su contenedor */
}

/* .btn-primary {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 2px 8px;
  cursor: pointer;
  transition: background-color 0.3s;
} */

/* .btn-primary:hover {
  background-color: #0056b3;
} */

/* .btn-secondary {
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 2px 12px;
  cursor: pointer;
  transition: background-color 0.3s;
} */

/* .btn-secondary:hover {
  background-color: #5a6268;
} */

.production-field {
  display: flex;
  align-items: center;
}

.production-field .v-input__control {
  display: flex;
  align-items: center;
}

.production-field .v-input__control > * {
  margin-right: 4px;
}
.flex-nowrap {
  flex-wrap: nowrap !important;
}
</style>
